// src/components/Cart.js
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  getCartItems,
  updateCartItem,
  removeItemFromCart,
  clearCart,
} from "../actions/cartActions";
import { toast } from "react-toastify";

import { CiSquareRemove } from "react-icons/ci";
import EngravingInput from "../components/EngravingInput";
import { Dialog, Transition } from "@headlessui/react";
import { BiMessageSquareEdit } from "react-icons/bi";
import { IoMdCloseCircle } from "react-icons/io";
import { ScrollToTop } from "../components/ScrollToTop";
import { checkCoupon } from "../actions/couponActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { CHECK_COUPON_RESET } from "../constants/couponConstants";
import OutlineBadge from "../components/Badge/OutlineBadge";
import ColoredBadge from "../components/Badge/ColoredBadge";

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [code, setCode] = useState("");
  const [engravingText, setEngravingText] = useState(""); // State for engraving text
  const [openAccordions, setOpenAccordions] = useState({});
  const [isAccordionOpen, setIsAccordionOpen] = useState(false); // State to track Accordion state
  const [selectedSize, setSelectedSize] = useState(0);

  const cart = useSelector((state) => state.cart);
  const { cartItems, successAdd, successUpdate, successRemove } = cart;

  const [localCartItems, setlocalCartItems] = useState([]);

  console.log("Cart Data --->", cart);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;


  // ✅ Add this line here
  const currentCartItems = userInfo ? cartItems : localCartItems;

  const couponValidation = useSelector((state) => state.couponValidation);
  const {
    loading,
    error: errorCoupon,
    isValid,
    discount,
    type,
    maxLimit,
  } = couponValidation;

  useEffect(() => {

    if (!userInfo) {
      // navigate("/signup");
      const localCart = JSON.parse(localStorage.getItem("savedCart")) || [];
      setlocalCartItems(localCart);

      const handleUpdate = () => {
        const localCart = JSON.parse(localStorage.getItem("savedCart")) || [];
        setlocalCartItems(localCart);
      };

      window.addEventListener("localCartUpdated", handleUpdate);

      // cleanup listener
      return () => {
        window.removeEventListener("localCartUpdated", handleUpdate);
      };
    } else {
      dispatch(getCartItems());
      dispatch({ type: CHECK_COUPON_RESET });
    }
  }, [dispatch, successAdd, successUpdate, successRemove, userInfo]);

  useEffect(() => {
    if (cartItems && cartItems?.length > 0) {
      if (cartItems?.some((item) => !item.product?._id)) {
        dispatch(getCartItems());
      }
    }
  }, [cartItems]);


  cart.itemsPrice = currentCartItems?.reduce(
    (acc, item) =>
      acc +
      (item?.product?.categories?.some(
        (category) => category.name === "ANKLETS"
      )
        ? item.isPair
          ? item.price * 2 * item.qty
          : item.price * item.qty
        : item.price * item.qty),
    0
  );

  cart.giftWrapTotalCost = currentCartItems?.reduce(
    (acc, currVal) => acc + (currVal.giftWrap ? currVal.qty * 50 : 0),
    0
  );

  cart.shippingPrice = 0; //cart.itemsPrice < 1000 ? 1000 : 0;
  cart.taxPrice = 0; //(18 * cart.itemsPrice) / 100;

  cart.discount =
    type !== null && type === "percentage"
      ? cart.itemsPrice * (discount / 100)
      : type !== null && type === "fixed"
        ? discount
        : 0;

  const totalBeforeDiscount =
    currentCartItems?.reduce(
      (acc, item) =>
        acc +
        (item?.product?.categories?.some(
          (category) => category.name === "ANKLETS"
        )
          ? item.isPair
            ? item.price * 2 * item.qty
            : item.price * item.qty
          : item.price * item.qty),
      0
    ) +
    (currentCartItems?.reduce(
      (acc, item) => acc + 10 * item?.engraveMen.length * item.qty,
      0
    ) +
      currentCartItems?.reduce(
        (acc, item) => acc + 10 * item?.engraveWomen.length * item.qty,
        0
      ) +
      currentCartItems?.reduce(
        (acc, item) =>
          acc + 10 * item?.petFrontEng.reduce((sum, text) => sum + text.length, 0),
        0
      ) +
      currentCartItems?.reduce(
        (acc, item) =>
          acc + 10 * item?.petBackEng.reduce((sum, text) => sum + text.length, 0),
        0
      )) +
    currentCartItems
      ?.filter((item) => item.giftWrap)
      ?.reduce((acc, item) => acc + 50 * item.qty, 0);

  // Engraving Total

  const angravingTotal = (
    currentCartItems?.reduce(
      (acc, item) => acc + 10 * (item?.engraveMen?.length || 0) * item.qty,
      0
    ) +
    currentCartItems?.reduce(
      (acc, item) => acc + 10 * (item?.engraveWomen?.length || 0) * item.qty,
      0
    ) +
    currentCartItems?.reduce(
      (acc, item) => acc + 10 * (item?.petFrontEng?.reduce((sum, text) => sum + text.length, 0) || 0),
      0
    ) +
    currentCartItems?.reduce(
      (acc, item) => acc + 10 * (item?.petBackEng?.reduce((sum, text) => sum + text.length, 0) || 0),
      0
    )
  )?.toLocaleString("en-IN");

  const couponMaxLimit = type === "percentage" && cart.discount > maxLimit ? maxLimit : 0;

  const discountToApply = couponMaxLimit > 0 ? couponMaxLimit : cart.discount;

  cart.totalPrice = Math.max(0, totalBeforeDiscount - discountToApply)?.toLocaleString("en-IN");

  const remainingBalance = type === "fixed" ? Math.max(0, cart.discount - totalBeforeDiscount) : 0;

  const handleGiftWrapChange = (
    productId,
    variantId,
    qty,
    sizeMen,
    sizeWomen,
    giftWrap,
    message,
    engraveMen,
    engraveWomen
  ) => {
    dispatch(
      updateCartItem(
        productId,
        variantId,
        qty,
        sizeMen,
        sizeWomen,
        !giftWrap,
        message,
        engraveMen,
        engraveWomen
      )
    );
  };

  const handleMessageChange = (
    productId,
    variantId,
    qty,
    sizeMen,
    sizeWomen,
    giftWrap,
    value,
    engraveMen,
    engraveWomen
  ) => {
    // console.log(value);
    dispatch(
      updateCartItem(
        productId,
        variantId,
        qty,
        sizeMen,
        sizeWomen,
        giftWrap,
        value,
        engraveMen,
        engraveWomen
      )
    );
  };

  const handleAccordionToggle = (isOpen) => {
    setIsAccordionOpen(isOpen); // Toggle Accordion state
    if (!isOpen) {
      setEngravingText(""); // Clear engraving text when Accordion is closed
    }
  };

  const toggleAccordion = (itemId) => {
    setOpenAccordions((prevState) => ({
      ...prevState,
      [itemId]: !prevState[itemId], // Toggle the state for the specific item
    }));
  };

  const increaseQtyHandler = (
    productId,
    variantId,
    qty,
    sizeMen,
    sizeWomen,
    giftWrap,
    message,
    engraveMen,
    engraveWomen
  ) => {
    dispatch(
      updateCartItem(
        productId,
        variantId,
        qty + 1,
        sizeMen,
        sizeWomen,
        giftWrap,
        message,
        engraveMen,
        engraveWomen
      )
    );
  };

  const decreaseQtyHandler = (
    productId,
    variantId,
    qty,
    sizeMen,
    sizeWomen,
    giftWrap,
    message,
    engraveMen,
    engraveWomen
  ) => {
    if (qty > 1) {
      dispatch(
        updateCartItem(
          productId,
          variantId,
          qty - 1,
          sizeMen,
          sizeWomen,
          giftWrap,
          message,
          engraveMen,
          engraveWomen
        )
      );
    } else {
      dispatch(removeItemFromCart(productId, variantId));
    }
  };

  const removeFromCartHandler = (productId, variantId) => {
    if (userInfo) {
      dispatch(removeItemFromCart(productId, variantId));
    } else {
      const localCart = JSON.parse(localStorage.getItem("savedCart")) || [];
      const index = localCart.findIndex(item => item._id === productId && item.variant === variantId);

      if (index > -1) {
        localCart.splice(index, 1);
        toast.success("Item removed from cart");

      }
      localStorage.setItem("savedCart", JSON.stringify(localCart));

      // Dispatch custom event to notify wishlist updated
      window.dispatchEvent(new Event("localCartUpdated"));

      // setIsWishlisted(index === -1);
    }
  };


  const clearCartHandler = () => {
    dispatch(clearCart());
  };

  const handlePlaceOrder = () => {
    navigate("/shipping");
  };

  const handleCouponApply = () => {
    cart.couponCode = code;
    dispatch(checkCoupon(code));
  };

  // console.log('CART',cart);
  // console.log('CART items',cartItems);

  return (
    <div className="max-w-6xl mx-auto p-6">
      <h2 className="text-xl md:text-2xl lg:text-3xl mb-4 text-center font-semibold">Cart Items</h2>
      {(userInfo ? cartItems : localCartItems)?.length === 0 ? (
        <div className="flex flex-col gap-3 w-full items-center justify-center col-span-5">
          <h3 className="text-[#000080] text-base font-semibold">
            Your cart is empty.
          </h3>
          <img
            src="../../empty-cart.png"
            className="w-1/2 md:w-1/4"
            alt="Your cart is empty. "
            loading="lazy"
          />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div>
            {(userInfo ? cartItems : localCartItems)?.map((item) => (
              <div
                key={`${item.product?._id}-${item.variant}`}
                className="flex flex-col"
              >
                <div className="flex relative items-center gap-6 mt-4 py-4 border-t-2 border-gray-200">
                  <Link
                    to={`/product/${item.product.name?.replaceAll(" ", "-")}/${item.product._id
                      }?variant=${item.product?.variants?.length > 0 &&
                      item.product?.variants?.filter(
                        (variant) => variant._id === item.variant
                      )[0]?._id
                      }`}
                    className="flex w-1/3 items-center border aspect-1 rounded-lg"
                  >
                    <img
                      src={item.image}
                      alt={item.name}
                      className="object-center object-cover rounded-lg"
                      loading="lazy"
                    />
                  </Link>

                  <div className="flex w-2/3 flex-col text-[12px] font-semibold gap-2">
                    <Link
                      to={`/product/${item.product.name?.replaceAll(
                        " ",
                        "-"
                      )}/${item.product._id}?variant=${item.product?.variants?.length > 0 &&
                      item.product?.variants?.filter(
                        (variant) => variant._id === item.variant
                      )[0]?._id
                        }`}
                      className="flex items-center gap-2"
                    >
                      {item.name}{" "}
                      {item.products?.length > 0 ? (
                        <ColoredBadge
                          text={"Customized Set"}
                          bgColor={"bg-[#000080]"}
                          textColor={"text-white"}
                          className={"rounded-sm "}
                        />
                      ) : (
                        ""
                      )}
                    </Link>
                    <div
                      className={`${item?.product?.categories?.some(
                        (cat) => cat.name === "Rings"
                      )
                        ? "block"
                        : "hidden"
                        }`}
                    >
                      {item?.product?.subcategories?.some(
                        (subcat) => subcat?.name === "Couple Rings"
                      ) ? (
                        <div className="flex flex-col">
                          <div>Size Men - {item.sizeMen}</div>
                          <div>Size Women - {item.sizeWomen}</div>
                        </div>
                      ) : (
                        <div>
                          Size
                          {item?.product?.gender === "female"
                            ? ` - ${item.sizeWomen}`
                            : ` - ${item.sizeMen}`}
                        </div>
                      )}
                    </div>

                    <div
                      className={`${item?.product?.categories?.some(
                        (cat) => cat.name === "ANKLETS"
                      ) || item?.isPair
                        ? "block"
                        : "hidden"
                        }`}
                    >
                      <div className="flex justify-start items-center gap-2">
                        <p>Anklets Type -</p>{" "}
                        <OutlineBadge
                          text={item.isPair ? "Pair" : "Single"}
                          bgColor={"bg-transprent"}
                          textColor={"text-[#000080]"}
                          className={"rounded-sm border border-[#000080]"}
                        />
                      </div>
                    </div>

                    <div className="flex items-center">
                      <button
                        onClick={() => {
                          if (userInfo) {
                            decreaseQtyHandler(
                              item.product?._id,
                              item.variant,
                              item.qty
                            )
                          } else {
                            const savedCart = JSON.parse(localStorage.getItem("savedCart")) || [];

                            const updatedCart = savedCart.reduce((acc, cartItem) => {
                              if (
                                cartItem._id === item.product?._id &&
                                cartItem.variant === item.variant
                              ) {
                                if (cartItem.qty > 1) {
                                  acc.push({ ...cartItem, qty: cartItem.qty - 1 });
                                }
                                // else: don't push it to remove it
                              } else {
                                acc.push(cartItem);
                              }
                              return acc;
                            }, []);

                            localStorage.setItem("savedCart", JSON.stringify(updatedCart));
                            window.dispatchEvent(new Event("localCartUpdated"));
                          }
                        }
                        }
                        className="px-2 py-1 border"
                      >
                        -
                      </button>
                      <span className="px-2">{item.qty}</span>
                      <button
                        onClick={

                          () => {
                            if (userInfo) {
                              increaseQtyHandler(
                                item.product?._id,
                                item.variant,
                                item.qty
                              )
                            } else {
                              // Guest user: update localStorage
                              const savedCart = JSON.parse(localStorage.getItem("savedCart")) || [];

                              const updatedCart = savedCart.map((cartItem) => {
                                if (
                                  cartItem._id === item.product?._id &&
                                  cartItem.variant === item.variant
                                ) {
                                  return {
                                    ...cartItem,
                                    qty: cartItem.qty + 1,
                                  };
                                }
                                return cartItem;
                              });

                              localStorage.setItem("savedCart", JSON.stringify(updatedCart));
                              window.dispatchEvent(new Event("localCartUpdated")); // Notify UI to update

                            }
                          }
                        }
                        className="px-2 py-1 border"
                      >
                        +
                      </button>
                    </div>

                    <div className="flex gap-3 items-end">
                      <h3 className="font-bold text-[16px]">
                        ₹{" "}

                        {item?.product?.categories?.some(
                          (category) => category.name === "ANKLETS"
                        )
                          ? item.isPair
                            ? (item.price * 2 * item.qty)?.toLocaleString(
                              "en-IN"
                            )
                            : (item.price * item.qty)?.toLocaleString("en-IN")
                          : (item.price * item.qty)?.toLocaleString("en-IN")}
                      </h3>
                      <h3 className="text-[12px] font-[500] text-gray-400 line-through">
                        ₹{" "}

                        {item?.product?.categories?.some(
                          (category) => category.name === "ANKLETS"
                        )
                          ? item.isPair
                            ? (item.basePrice * 2 * item.qty)?.toLocaleString(
                              "en-IN"
                            )
                            : (item.basePrice * item.qty)?.toLocaleString(
                              "en-IN"
                            )
                          : (item.basePrice * item.qty)?.toLocaleString(
                            "en-IN"
                          )}
                      </h3>
                      <h3
                        className={`${item?.product?.discountedPercent === 0 ? "hidden" : ""
                          } inline-block text-[12px] text-[#000080]`}
                      >
                        {(
                          ((item?.basePrice - item?.price) / item?.basePrice) *
                          100
                        )?.toFixed(0)}
                        %
                      </h3>
                    </div>
                    {userInfo && (
                      <button
                        onClick={() => toggleAccordion(item._id)}
                        className="flex truncate gap-2 px-2 py-1 items-center rounded-md border border-gray-300 uppercase"
                      >
                        <BiMessageSquareEdit className="w-5 h-5" />
                        <p
                          className={`${item?.product?.categories?.some(
                            (cat) => cat.name === "Rings"
                          )
                            ? "block"
                            : "hidden"
                            }`}
                        >
                          Change Size,{" "}
                        </p>
                        <p>Add Engraving and Gift Wrap</p>
                      </button>
                    )}


                    {openAccordions[item._id] && (
                      <Transition appear show={true} as={Fragment}>
                        <Dialog
                          as="div"
                          className="relative z-20"
                          onClose={() => toggleAccordion(item._id)}
                        >
                          <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <div className="fixed inset-0 bg-black/25" />
                          </Transition.Child>

                          <div className="fixed inset-0 overflow-y-auto">
                            <div className="flex min-h-full items-center justify-center p-4 text-center">
                              <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                              >
                                <Dialog.Panel className={`${item?.product?.categories?.some((cat) => cat.name === "JEWELLERY SETS")
                                  ? "w-1/2"
                                  : "w-full max-w-md"
                                  } transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}>
                                  <Dialog.Title
                                    as="h3"
                                    className="flex justify-between items-center text-lg font-medium leading-6 text-gray-900"
                                  >
                                    <h3>Manage Details</h3>
                                    <button onClick={() => toggleAccordion(item._id)}>
                                      <IoMdCloseCircle className="w-5 h-5 text-red-600" />
                                    </button>
                                  </Dialog.Title>
                                  <div className="mt-2">
                                    <EngravingInput
                                      key={item._id}
                                      item={item}
                                      setIsAccordionOpen={() => toggleAccordion(item._id)}
                                    />
                                  </div>
                                </Dialog.Panel>
                              </Transition.Child>
                            </div>
                          </div>
                        </Dialog>
                      </Transition>
                    )}

                  </div>
                  <button
                    onClick={() =>
                      removeFromCartHandler(item.product?._id, item.variant)
                    }
                    className="absolute top-4 right-4 px-2 py-1"
                  >
                    <CiSquareRemove className="w-6 h-6" />
                  </button>
                </div>
                {/* <GiftInput key={item._id} item={item} /> */}
              </div>
            ))}
          </div>
          <div className="flex w-full flex-col gap-6">
            <div className="flex bg-gray-100 p-4 items-center gap-4 justify-center mb-4">
              <img src="https://d1lfl311x81a6w.cloudfront.net/products/1730092469534.png" loading="lazy" />
              <p>
                Yay! <strong>No Delivery Charge</strong> on this order.
              </p>
            </div>

            <div className="flex flex-col gap-4 relative mb-4">
              <div className="font-bold">Have a Coupon?</div>
              <input
                className="p-2 bg-gray-100 border-1 border-gray-300 rounded"
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder={userInfo ? "Enter Coupon Code" : "Please sign-in to use coupon"}
                readOnly={!userInfo}
              />
              {userInfo && (
                <button
                  onClick={() => handleCouponApply()}
                  className="absolute right-4 top-[50px] text-sm text-[#000080] font-bold"
                >
                  APPLY
                </button>
              )}

              {loading ? (
                <Loader />
              ) : errorCoupon ? (
                <Message type="error">{errorCoupon}</Message>
              ) : isValid ? (
                <div>Thank You For Applying Coupon</div>
              ) : (
                <></>
              )}
            </div>

            <div className="flex flex-col gap-6">
              <h2 className="font-bold">{`PRICE DETAILS (${currentCartItems?.reduce(
                (acc, item) => acc + 1 * item.qty,
                0
              )} ITEMS)`}</h2>
              <div className="flex justify-between text-sm text-gray-500">
                <div>Total MRP</div>
                <div>
                  ₹{" "}
                  {currentCartItems
                    ?.reduce(
                      (acc, item) =>
                        acc +
                        // (item.isPair
                        //   ? item.basePrice * 2 * item.qty
                        //   : item.basePrice * item.qty)
                        (item?.product?.categories?.some(
                          (category) => category.name === "ANKLETS"
                        )
                          ? item.isPair
                            ? item.basePrice * 2 * item.qty
                            : item.basePrice * item.qty
                          : item.basePrice * item.qty),
                      0
                    )
                    ?.toLocaleString("en-IN")}
                </div>
              </div>
              <div className="flex justify-between text-sm text-gray-500">
                <div>Discount on MRP</div>
                <div className="text-green-500">
                  -₹{" "}
                  {(
                    currentCartItems?.reduce(
                      (acc, item) =>
                        acc +
                        (item?.product?.categories?.some(
                          (category) => category.name === "ANKLETS"
                        )
                          ? item.isPair
                            ? item.basePrice * 2 * item.qty
                            : item.basePrice * item.qty
                          : item.basePrice * item.qty),
                      0
                    ) -
                    currentCartItems?.reduce(
                      (acc, item) =>
                        acc +
                        (item?.product?.categories?.some(
                          (category) => category.name === "ANKLETS"
                        )
                          ? item.isPair
                            ? item.price * 2 * item.qty
                            : item.price * item.qty
                          : item.price * item.qty),
                      0
                    )
                  )?.toLocaleString("en-IN")}
                </div>
              </div>
              {isValid && (
                <div className="flex justify-between text-sm text-gray-500">
                  <p className="">
                    Coupon Discount ({discount}
                    {type !== null && type === "percentage" ? " %" : " Off"})
                  </p>
                  <p className="text-green-500">
                    {type === "percentage" && couponMaxLimit > 0 ? "" : "-"}₹ {cart.discount?.toFixed(0)}
                  </p>
                </div>
              )}

              {isValid && remainingBalance > 0 && (
                <div className="flex justify-between text-sm text-gray-500">
                  <div>Remaining Balance from Coupon</div>
                  <div className="text-green-500">₹ {remainingBalance.toLocaleString("en-IN")}</div>
                </div>
              )}

              {isValid && couponMaxLimit > 0 && (
                <div className="flex justify-between text-sm text-gray-500">
                  <div>Coupon Max Limit</div>
                  <div className="text-green-500">-₹ {couponMaxLimit.toLocaleString("en-IN")}</div>
                </div>
              )}

              {isValid && (
                <div className="flex justify-between text-sm text-gray-500">
                  <p className="">Coupon Code</p>
                  <p className="">{cart.couponCode}</p>
                </div>
              )}
              
              {currentCartItems?.some(
                (item) =>
                  item?.engraveMen !== "" ||
                  item.engraveWomen !== "" || item.petFrontEng.length > 0 ||
                  item.petBackEng.length > 0
              ) && (
                  <div className="flex justify-between text-sm text-gray-500">
                    <div>Engraving Charge (₹ 10 Per Character)</div>
                    <div>
                      ₹ {angravingTotal}
                    </div>
                  </div>
                )}
              {currentCartItems?.some((item) => item?.giftWrap) && (
                <div className="flex justify-between text-sm text-gray-500">
                  <div>Gift Charge</div>
                  <div>
                    ₹{" "}
                    {currentCartItems
                      ?.filter((item) => item.giftWrap)
                      ?.reduce((acc, item) => acc + 50 * item.qty, 0)
                      ?.toLocaleString("en-IN")}
                  </div>
                </div>
              )}

              <div className="flex justify-between text-sm text-gray-500">
                <div>Delivery Charge</div>
                <div className="text-green-500">Free</div>
              </div>

              <div className="flex justify-between border-t-2 border-gray-200 font-bold pt-4">
                <div>Total Amount</div>
                <div>
                  ₹{" "}
                  {/* {(
                    currentCartItems?.reduce(
                      (acc, item) =>
                        acc +
                        (item?.product?.categories?.some(
                          (category) => category.name === "ANKLETS"
                        )
                          ? item.isPair
                            ? item.price * 2 * item.qty
                            : item.price * item.qty
                          : item.price * item.qty),
                      0
                    ) +
                    (currentCartItems?.reduce(
                      (acc, item) =>
                        acc + 10 * item?.engraveMen.length * item.qty,
                      0
                    ) +
                      currentCartItems?.reduce(
                        (acc, item) =>
                          acc + 10 * item?.engraveWomen.length * item.qty,
                        0
                      ) + currentCartItems?.reduce(
                        (acc, item) => acc + 10 * item?.petFrontEng.reduce((sum, text) => sum + text.length, 0),
                        0
                      ) + currentCartItems?.reduce(
                        (acc, item) => acc + 10 * item?.petBackEng.reduce((sum, text) => sum + text.length, 0),
                        0
                      )) +
                    currentCartItems
                      ?.filter((item) => item.giftWrap)
                      ?.reduce((acc, item) => acc + 50 * item.qty, 0) -
                    cart.discount
                  )?.toLocaleString("en-IN")} */}
                  {cart.totalPrice}
                </div>
              </div>

              <div className="flex w-full">
                <button
                  onClick={() => handlePlaceOrder()}
                  className="w-full bg-[#000080] flex text-white p-4 font-semibold gap-4 justify-center items-center"
                >
                  Place Order
                  <img
                    src="https://d1lfl311x81a6w.cloudfront.net/products/1730092371657.png"
                    alt="arr"
                    loading="lazy"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center w-full px-4 my-10 lg:mb-0">
        <Link
          to={`/`}
          className="flex items-center justify-center w-full md:w-1/5 p-2 md:p-3 text-[#000080] border border-[#000080] rounded-md hover:bg-[#000080] hover:border-[#000080] hover:text-gray-100"
        >
          Continue Shopping
        </Link>
      </div>
    </div>
  );
};

export default Cart;
